import React from 'react';

import { GoogleAnalyticsDataAuthWrapper } from '@hydra/common/components/GoogleAnalytics/GoogleAnalyticsDataWrapper';
import { useI18n } from '@hydra/common/components/i18n';
import Criterium from '@hydra/common/criterium/Criterium';
import CriteriumChart from '@hydra/common/criterium/CriteriumChart';
import getGraphData from '@hydra/utils/getGraphData';
import ReviewSkeleton from '@hydra/common/components/ReviewSkeleton';
import { CriteriumInterface } from '@hydra/types/review';

function BehaviorsGraph ({ data }: { data: string[] }) {
  const { translate } = useI18n();
  const chartData = [{
    name: translate('pj_ga_avgTime'),
    data: (data || []).map(([x, y]) => getGraphData({ x, y }))
  }];
  return (
    <CriteriumChart
      type='time'
      frequency='month'
      hasLegend
      hasTooltip
      data={chartData}
    />
  );
}

const report =
{
  reportType: 'ga',
  query: {
    metrics: 'ga:avgTimeOnPage',
    dimensions: 'ga:yearmonth',
    'end-date': 'yesterday',
    'start-date': '365daysAgo'
  }
};

interface PjGaAudienceBehaviorsCriterium extends CriteriumInterface {
  data: { viewId: string, accessToken: string }
}

export function PjGaAudienceBehaviors ({
  criterium
}: {
  criterium: PjGaAudienceBehaviorsCriterium
}) {
  return (
    <Criterium criterium={criterium || { type: 'pj_ga_audience_behaviors', score: null, importance: 0, solvability: 0 }} clickable={!!criterium}>
      {criterium
        ? (
          <GoogleAnalyticsDataAuthWrapper
            accessToken={criterium.data && criterium.data.accessToken}
            viewId={criterium.data && criterium.data.viewId}
            report={report}
            Component={BehaviorsGraph}
            loadingComponent={<ReviewSkeleton height={300} />}
          />
          )
        : <ReviewSkeleton height={300} />}
    </Criterium>
  );
}

export default React.memo(PjGaAudienceBehaviors);
